<template>
  <div id="app" class="bg-cinza">
    <div style="border:none;" class="menutopo2 ">
      <menu-topo :rotas="itensMenu" class="" />
    </div>
    <transition name="transicao-pagina">
      <router-view class="view" />
    </transition>
    <rodape />
  </div>
</template>

<script>
import menuTopo from "./shared/menuTopo/menuTopo";
import { routes } from "./routes/index";
import serviceHome from "./services/ServiceHome";
import serviceCookie from "./services/ServiceCookie";
import rodape from "./shared/rodape/rodape";

export default {
  components: {
    "menu-topo": menuTopo,
    rodape
  },
  name: "App",
  data() {
    return {
      routes: routes,
      width: "",
      usuario: null,
      existeCookie: false
    };
  },

  beforeCreate() {
      let temCookie = serviceCookie.existe("usuario");
     if (!temCookie)
      window.location.href = "https://www.lefisc.com.br/incorrectLogin.aspx";
  },

  async created() {
    
     //serviceCookie.criarCookie();
     this.existeCookie = serviceCookie.existe("usuario");

     if (this.existeCookie) {
       //pega o Id Usuário do Cookie se tiver
       this.usuario = serviceCookie.getCookie("idCliente");
       if (this.usuario.length > 0) {
         this.usuario = serviceCookie.getCookie("idCliente");
         console.log(this.usuario)
         this.usuario = parseInt(this.usuario);
         if (!this.usuario) this.usuario = 0;
      }

       //else await serviceCookie.criarCookie();
       let contador = 0;
       await serviceHome.getContadorNCMs(31).then(res => {
        contador = res;
       });

       if (contador > 0) {
         this.routes.forEach(rota => {
           if (rota.name == "Minhas NCMs") rota.menu = true;
           if (rota.name == "Pesquisa") rota.menu = true;
           if (rota.name == "Home") rota.menu = false;
         });
         this.$router.push({ name: "Minhas NCMs" });
       } else {
         this.routes.forEach(rota => {
           if (rota.name == "Home") rota.menu = true;
         });
         this.$router.push({ name: "Home" });
       }
     }
     
   },
   watch:{
      '$route' (to, from) {
        
    }
   },
   mounted(){
     
     console.log(this.$store.state.idCliente)
   },
  computed: {
    
    itensMenu() {
      return this.routes.filter(item => item.menu);
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Aleo");
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.css");
.bg-cinza {
  background-color: #eff3f5;
  position: relative;
}
#app {
  font-family: "Segoe", sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
}

.box-nota{
  border: 1px solid #ddd;
  height: max-content;
  border-radius: 5px;
}

.box-nota * {
  text-align: justify;
}

.transicao-pagina-enter {
  opacity: 0;
}

.transicao-pagina-enter-to {
  opacity: 1;
}

.transicao-pagina-enter-active {
  transition: opacity 0.5s;
}

.transicao-pagina-leave {
  opacity: 0;
}

.transicao-pagina-leave-to {
  opacity: 1;
}

.transicao-pagina-leave-active {
  transition: opacity 0.5s;
}

.tela-enter {
  transform: translateX(-50%);
}

.tela-enter-to {
  transform: translateX(0);
}

.tela-leave {
  transform: translateX(0);
}

.tela-leave-to {
  transform: translateX(100%);
}

.tela-enter-active {
  transition: all 0.5s;
}
</style>
<style>
@keyframes exibir {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeW {
  animation-name: exibir;
  animation-direction: normal;
  animation-duration: 0.7s;
  animation-fill-mode: both;
}

body::-webkit-scrollbar {
  width: 10px;
  background: #f8f8f8;
} /* configurando scroll */

body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.089);
}

body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #b3b3b3;
}

.menutopo2 {
  min-height: 60px;
  background-color: white;
  border-bottom: 1px solid #ddd;
}

.menutopo {
  min-height: 60px;
  background-color: white;
  border-bottom: 1px solid #ddd;
}

.view {
  min-height: 87vh;
}


@media (max-width: 320px) {
  .menutopo2 {
    min-height: 60px;
  }

  .menutopo {
    min-height: 60px;
  }
}
</style>
